import CardContent from "@mui/material/CardContent";
import React from "react";
import CarouselCardImage from "./CarouselCardImage";
import {
    card,
    cardBadge,
    cardInner,
    cardTitle,
    cardTitleWrap,
} from "../styles/DashboardStyles";
import { useNavigate } from "react-router-dom";
import CardRowProps from "interfaces/CardRowProps.interface";
import { CardRowStyle } from "styles/CardRow.style";
import CarouselStyle from "styles/Carousel.style";

export default function CardRow({ apps, user, width }: CardRowProps) {
    const navigate = useNavigate();
    return (
        <div
            style={CardRowStyle}
            onDragStart={(e) => {
                e.preventDefault();
            }}
        >
            {apps.map((app, index) => (
                <div
                    style={CarouselStyle(card, width)}
                    key={index}
                >
                    {typeof app.badgeCount === 'number' && app.badgeCount >= 0 && (
                        <div
                            style={{
                                ...cardBadge,
                                ...(app.badgeCount > 0 ? { animation: "badgePulse 1.6s ease-in-out infinite" } : {}),
                            }}
                        >
                            {app.badgeCount}
                        </div>
                    )}
                    <div style={cardInner}>
                        <CardContent style={{ padding: '0', margin: '0' }}>
                            <a
                                href={app.link}
                                target={user ? '_blank' : undefined}
                                onClick={(e) => {
                                    if (!user) {
                                        e.preventDefault();
                                        navigate('/login');
                                    }
                                }}
                            >
                                <CarouselCardImage app={app} />
                            </a>
                        </CardContent>
                        <div style={cardTitleWrap}>
                            <div style={cardTitle}>{app.name}</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
